import { createElement, styled, compose, position, layout, flexbox, color, space } from '@vebox/etui-system';

const FormElement = createElement('form');
const Form = styled(FormElement)(compose(position, layout, flexbox, color, space));
Form.displayName = 'Form';

export { Form };
